
jQuery.widget("common.vcBaseV4", $.common.VisualBase, {
    myRoot: null,  //visual root element 
    myHtml: null,    //html structure
    mySettings: {}, //optional visual settings
    myStatus: {},   //current status attributes
    myData: null,   //data objects
    vcV: new vcVisual(), 
    vcC: new vcCommon(), 


    _createVisual: function (vcvid) {
        /// <summary>
        /// This function sets the visual id and assignes the myRoot object based on the given css class
        /// </summary>
        var me = this;
      
        me.element.html("");

        // set the Visual-Name first
        me.options.invoke.vcvid = vcvid;
        me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
        return true;
    },


    _setRoot: function (selector) {
        this.myRoot = this.element.find(selector);
    },

    _setObj: function (id, cssClass) {
        /// <summary>
        /// creates an object (div) with optional id and css classes
        /// </summary>
        var obj = $("<div>");
        if (id.length > 0) obj.attr("id", id);
        if (cssClass.length > 0) obj.addClass(cssClass);
        return obj;
    },


    _setInput: function (id, cssClass) {
        /// <summary>
        /// creates an input field with optional id and css classes
        /// </summary>
        var obj = $("<input>");
        if (id.length > 0) obj.attr("id", id);
        if (cssClass.length > 0) obj.addClass(cssClass);
        return obj;
    },
    _setTextArea: function (id, cssClass) {
        /// <summary>
        /// creates an input field with optional id and css classes
        /// </summary>
        var obj = $("<textarea>");
        if (id.length > 0) obj.attr("id", id);
        if (cssClass.length > 0) obj.addClass(cssClass);
        return obj;
    },

    _setWrapper: function (id, cssClass) {
          /// <summary>
        /// creates a wrapper object with a pre-defined name and default css classes
        /// </summary>
        return this._setObj(id, "wrapper vc-grid-margin-bottom " + cssClass);
    },

    _setFieldset: function (id, cssClass, legendText) {
        /// <summary>
        /// creates a fieldset with optional id, css classes and legend text
        /// </summary>       
        var obj = $("<div>");
        if (id.length > 0) obj.attr("id", id);
        let classes = "formFieldset box";
        if (cssClass.length > 0) classes += " " + cssClass;
        obj.addClass(classes);
/*        obj.append($("<legend>").text(legendText));*/
        return obj;
    },
  


    _setMainButton: function (id, icon, label) {
         /// <summary>
        /// creates a pre-defined main button item
        /// </summary>
        return this._setObj(id, "btnMainItem standard vc-grid-margin-right float-box").html(icon + "<p>" + label + "</p>");
    },
    _setListHeader: function (id) {
        /// <summary>
        /// creates a default list header
        /// </summary>
        return this._setObj(id, "vc-list-header color-bg-secondary");
    },
    _setListItem: function () {
        /// <summary>
        /// creates a list line with a default column
        /// </summary>
        var item = this._setObj("", "vc-list-item");
        var col = this._setObj("", "vc-list-col");
        item.append(col);
        return {item: item, column: col}
    },

    _setListElement: function (id, cssClass) {
        /// <summary>
        /// creates a  list element
        /// </summary>
        return this._setObj(id, "vc-list-col-element " + cssClass);
  
    },

    _setLoadingIcon: function (obj) {
        /// <summary>
        /// sets a nicer loading icon
        /// </summary>
        obj.html("<p>" + this.getLoadingIcon() + "</p>");

    },

    _doFilter: function (obj, cssPrefix) {
        /// <summary>
        /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            //hide all
            var items = obj.find(".vc-list-item");
            items.removeClass("found").data("counter", 0).hide();

            //we add the 'found' class to all items we want to filter based on the vcfilter tags
            me.setTagFilter(".vc-filter", cssPrefix + " .vc-list-item", "found");

            items.filter(".found").show();
            me._setAltListStyle(obj);

            return true;
        } catch (ex) {
            me._writeErr(e);
            return false;
        }

    },

    _doListTableFilter: function (obj) {
        /// <summary>
        /// simpified filter for list tables only!!
        /// </summary>
        this._doFilter(obj, ".vc-list-table")

    },

    _setAltListStyle: function (obj) {
         /// <summary>
        /// sets a nicer loading icon
        /// </summary>
          obj.find(".vc-list-item").removeClass("alt").filter(".found:even").addClass("alt");
    },

    _getVisualHeight: function () {
        /// <summary>
        /// get total height
        /// </summary>
        return parseInt(this.myRoot.height());
    },


    _getVisualWidth: function () {
        /// <summary>
        /// get total width
        /// </summary>
        return parseInt(this.myRoot.width());
    },

    _syncListHeaderToEntries: function (header, entries) {
        /// <summary>
        /// syncs the list header padding to the entries container scrollbar width
        /// </summary>
        try {
            if (!header || !entries || header.length === 0 || entries.length === 0) return;

            // get scrollbar width
            var el = entries.get(0);
            if (!el) return;
            var wScrollbar = el.offsetWidth - el.clientWidth; 
            // set padding in the header on the right side (because we have no scrollbar in the header, but in the entries)
            header.css("padding-right", wScrollbar > 0 ? wScrollbar + "px" : "0px");
        } catch (e) {
            return null;
        }
    },


});
